"use client";

import { resolveUnknown } from "./binding";
import type { RecordAny } from "./types";

export function childIds(children: unknown): string[] {
  if (!children || typeof children !== "object") return [];
  const explicit = (children as RecordAny).explicitList;
  return Array.isArray(explicit) ? explicit.filter((id): id is string => typeof id === "string") : [];
}

export function actionNameFromConfig(config: RecordAny): string {
  const action = config.action as RecordAny | undefined;
  return typeof action?.name === "string" ? action.name : "";
}

export function resolveActionContext(action: RecordAny | undefined, data: RecordAny): Record<string, unknown> {
  const contextEntries = Array.isArray(action?.context) ? action.context : [];
  const context: Record<string, unknown> = {};
  for (const entry of contextEntries) {
    if (!entry || typeof entry !== "object" || typeof (entry as RecordAny).key !== "string" || !(entry as RecordAny).key) continue;
    context[(entry as RecordAny).key as string] = resolveUnknown((entry as RecordAny).value, data);
  }
  return context;
}

